import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { LoginPartnerService } from 'src/app/services/partner/login-partner/login-partner.service';
import { MainService } from 'src/app/services/delavci/main.service';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { Message } from 'src/app/models/Message';
import * as moment from 'moment';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { User } from 'src/app/models/User';
import { Partner } from 'src/app/models/Partner';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})


export class MessagesComponent implements OnInit, OnChanges, AfterViewChecked {

  @Input() public taskId;
  public text;
  public messagesArray: Array<Message> = [];
  public htmlContent;
  public sessionUserPartner;
  public currentUserPartner: Partner;
  public currentUserWorker: User;
  public currentUserName;
  @ViewChild('scrollMe', {static: false}) private myScrollContainer: ElementRef;
  public editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '18vh',
      maxHeight: '18vh',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Vpišite sporočilo..',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [

    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['fontSize'],
      ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
      ['superscript', 'subscript'],
      ['indent', 'outdent'],
      ['customClasses']
    ]
  };
  constructor(private loginPartnerService: LoginPartnerService, private mainService: MainService,
              private helpdeskService: HelpdeskService) {
              }


  ngOnInit() {
    this.scrollToBottom();
    if (!this.loginPartnerService.currentSessionValue) {
      this.sessionUserPartner = null;
    } else {
      this.sessionUserPartner = this.loginPartnerService.currentSessionValue;
    }
    if (!this.loginPartnerService.currentPartnerValue) {
      this.currentUserPartner = null;
    } else {
      this.currentUserPartner = this.loginPartnerService.currentPartnerValue;
      this.currentUserName = this.loginPartnerService.currentPartnerValue.fullName;
    }
    if (!this.mainService.currentUserValue) {
      this.currentUserWorker = null;
    } else {
      this.currentUserWorker = this.mainService.currentUserValue;
      this.currentUserName = this.mainService.currentUserValue.workerNameSmall;
    }
    
  }

  getFormattedDate(messageDate) {
    return moment(messageDate).format('DD.MM.YYYY, hh:mm:ss');
  }

//uporabljen ngOnChanges, saj je preko inputa dobim taskId, zato sledimo njegovim spremembam
  ngOnChanges(changes: SimpleChanges) {
    if (this.taskId) {
      if ('taskId' in changes) {
        this.setMessageReadAll();
      }
    }
  }
  getMessages() {

      this.helpdeskService.getMessages(this.loginPartnerService.currentSessionValue, this.mainService.currentUserValue,
        this.loginPartnerService.currentPartnerValue,this.taskId).subscribe( data => {
          this.messagesArray = data.data.messages;
        }, error => {
          console.log(error);
        });

  }

  //pošiljam message glede na tip uporabnika
  setMessages() {
      this.helpdeskService.setMessages(this.sessionUserPartner, this.taskId, null,
        this.htmlContent, this.currentUserPartner, this.currentUserWorker).subscribe( data => {
          this.setMessageReadAll();
        }, error => {
          console.log(error);
        });
  }

  onSendMessage() {
    if (this.htmlContent != undefined) {
      this.setMessages();
      this.htmlContent = null;
    }
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
}

scrollToBottom(): void {
  try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
  } catch(err) {
    console.log(err);
  }
}

setMessageReadAll() {
  this.helpdeskService.setMessageReadAll(this.loginPartnerService.currentSessionValue, this.mainService.currentUserValue,
    this.loginPartnerService.currentPartnerValue, this.taskId).subscribe( data => {
      this.getMessages();
    }, error => {
      console.log(error);
    });
}
}
